export const devices = {
  phone: 767,
  mobile: 1023,
  laptop: 1024,
  desktop: 1441,
}

export const mediaQueries = (device: keyof typeof devices) => {
  return (style: TemplateStringsArray | String) => {
    if (['phone', 'mobile'].includes(device)) {
      return `@media (max-width: ${devices[device]}px) { ${style} }`
    }

    return `@media (min-width: ${devices[device]}px) { ${style} }`
  }
}
